 <template>
  <v-container fluid>
    <v-row v-if="!progress">
      <v-col>
        <v-card>
          <v-container>
            <v-card-title>
              <h4>{{ parent.name.familyName }}</h4>
              <span>　様のご家庭</span>
            </v-card-title>
            <v-card-text>
              <div>
                <span class="grey--text">最寄駅</span>
               　{{ parent.nearestStation }}
              </div>
            </v-card-text>
          </v-container>
          <v-divider></v-divider>
          <div
            v-for="student in this.students.get()"
            :key="student.id"
          >
            <v-container>
              <v-col>
                <v-card-title>
                  <h4>{{ student.name.personalName }}</h4>
                  <span>　さん</span>
                </v-card-title>
                <v-card-text>
                  {{ student.grade().toJapanese() }}
                  {{ student.genderInJapanese() }}
                </v-card-text>
                <v-card-text>
                  <span class="grey--text">指導希望時間帯</span>
                </v-card-text>
                <v-card-text>
                  <v-chip
                    v-for="schedule in student.availableSchedulesToStrings()"
                    :key="schedule"
                    class="ma-1"
                    outlined
                  >
                    {{ schedule }}
                  </v-chip>
                </v-card-text>
                <LessonOfferForm
                  :student="student"
                  :offers="offers"
                  @afterSending="afterSending"
                />
                <RemoveStudents
                  :student="student"
                  @deleteStudent="deleteStudent(student)"
                />
                <v-dialog
                  v-model="hasRemoved"
                  persistent
                  max-width="350px">
                  <v-card>
                    <v-row justify="center">
                      <v-card-title>
                        リクエストを解除しました。
                      </v-card-title>
                    </v-row>
                    <v-row justify="center">
                      <v-btn
                        text
                        outlined
                        class="ma-5"
                        @click="hasRemoved=false">
                        確認
                      </v-btn>
                    </v-row>
                  </v-card>
                </v-dialog>
              </v-col>
            </v-container>
            <v-divider></v-divider>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import LessonOfferForm from '@/components/organisms/teacher/LessonOfferForm.vue'
import RemoveStudents from '@/components/organisms/teacher/RemoveStudents.vue'

export default {
  name: "MatchingStudentsList",
  components: {
    'LessonOfferForm': LessonOfferForm,
    'RemoveStudents': RemoveStudents
  },
  data() {
    return {
      teacher: this.$store.getters.teacher,
      students: [],
      hasRemoved: false,
      progress: true,
      dialog: false
    }
  },
  props: {
    parent: Object,
    offers: Object
  },
  methods: {
    deleteStudent(student) {
      this.students.remove(student.id)
      if (this.students.get().length === 0) {
        this.$emit("deleteParent", this.parent)
      }
      this.hasRemoved = true
    },
    afterSending() {
      this.$emit("afterSending")
    }
  },
  created: function() {
    this.students = this.parent.students.filterByTeacherId(this.teacher.uuid)
    this.progress = false
  }
}
</script>